import { actions } from './Reducer';

export const getTrainingCentersAction = (body) => {
  return {
    type: actions.GET_TRAINING_CENTERS,
    payload: body,
  };
};

export const getTrainingCentersSuccessAction = (list) => ({
  type: actions.GET_TRAINING_CENTERS_SUCCESS,
  payload: list,
});

export const createTrainingCenterAction = (body, noRedirect) => {
  return {
    type: actions.CREATE_TRAINING_CENTER,
    payload: body,
    noRedirect,
  };
};

export const getSingleTrainingCenterAction = (id) => {
  return {
    type: actions.GET_SINGLE_TRAINING_CENTER,
    payload: id,
  };
};

export const getSingleTrainingCenterSuccess = (ts) => ({
  type: actions.GET_SINGLE_TRAINING_CENTER_SUCCESS,
  payload: ts,
});

export const createTrainingCenterSuccessAction = (trainingCenter) => ({
  type: actions.CREATE_TRAINING_CENTER_SUCCESS,
  payload: trainingCenter,
});

export const updateTrainingCenterAction = (id, formData, noRedirect) => ({
  type: actions.UPDATE_TRAINING_CENTER,
	payload: { id, formData },
	noRedirect
});

export const updateTrainingCenterSuccessAction = (formData) => ({
  type: actions.UPDATE_TRAINING_CENTER_SUCCESS,
  payload: formData,
});

export const deleteTrainingCenterAction = (id) => ({
  type: actions.DELETE_TRAINING_CENTER,
  payload: id,
});

export const deleteTrainingCenterSuccessAction = (ts) => ({
  type: actions.DELETE_TRAINING_CENTER_SUCCESS,
  payload: ts,
});

export const switchTrainingCenterAction = (id, formData) => ({
  type: actions.SWITCH_TRAINING_CENTER,
  payload : {
    id,
    formData
  }
})

export const switchTrainingCenterSuccessAction = (ts) => ({
  type: actions.SWITCH_TRAINING_CENTER_SUCCESS,
  payload: ts
})



export const addtrainingCenterCourseAction = (body) => ({
  type:actions.ADD_TRAINING_CENTER_COURSE,
  payload: body
})

export const addtrainingCenterCourseSuccessAction = (course) => ({
  type:actions.ADD_TRAINING_CENTER_COURSE_SUCCESS,
  payload: course
})


export const editTrainingCenterCourseAction = (body) => ({
  type: actions.EDIT_TRAINING_CENTER_COURSE,
  payload: body
})

export const editTrainingCenterCourseSuccessAction = (course) => ({
  type: actions.EDIT_TRAINING_CENTER_COURSE_SUCCESS,
  payload: course
})


export const deleteTrainingCenterCourseAction = (body) => ({
  type: actions.DELETE_TRAINING_CENTER_COURSE,
  payload: body
})

export const deleteTrainingCenterCourseSuccessAction = (course) => ({
  type: actions.DELETE_TRAINING_CENTER_COURSE_SUCCESS,
  payload: course
})

export const setTrainingCenterLoading = (loading) => ({
  type: actions.SET_TRAINING_CENTER_LOADING,
  payload: loading,
});

export const setTrainingCenterCount = (count) => ({
  type: actions.SET_TRAINING_CENTER_COUNT,
  payload: count,
});

export const setTrainingCenterSearchValueActon = (searchValue) => ({
  type: actions.SET_TRAINIG_CENTER_SEARCH_VALUE,
  payload: searchValue,
});
